import { darkerTheme, darkTheme, newTheme } from '@customerio/pluma-components/css';
import type { PlumaTheme } from '@customerio/pluma-components/css';

export type ResolvedPlumaThemes = {
  light: PlumaTheme;
  dark: PlumaTheme;
};

export const defaultPlumaThemes = {
  light: newTheme,
  dark: darkTheme,
} satisfies ResolvedPlumaThemes;

export function getPlumaThemes(isDarkerDarkThemeEnabled: boolean): ResolvedPlumaThemes {
  if (isDarkerDarkThemeEnabled) {
    return {
      light: newTheme,
      dark: darkerTheme,
    };
  }

  return defaultPlumaThemes;
}
